import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl } from '@angular/forms';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class CustomvalidationService {

  //aplica obrigatoriedade no formcontrol de acordo com o valor do checkbox
  checkboxConditionalRequired(checkboxName: string, formControlName: string, wantedValue: boolean) {
    return (formGroup: FormGroup) => {
      const checkbox = formGroup.controls[checkboxName];
      const formControl = formGroup.controls[formControlName];

      if (formControl.errors && !formControl.errors.conditionalRequired) {
        return;
      }

      if (wantedValue != false && wantedValue != true) {
        return;
      }

      if (wantedValue == false) {
        if ((checkbox.value == null || checkbox.value == wantedValue) && (formControl.value == null || formControl.value == '')) {
          formControl.setErrors({ conditionalRequired: true });
        }
        else {
          formControl.setErrors(null);
        }
      }

      else if (wantedValue == true) {
        if (checkbox.value == wantedValue && (formControl.value == null || formControl.value == '')) {
          formControl.setErrors({ conditionalRequired: true });
        }
        else {
          formControl.setErrors(null);
        }
      }  
    }
  }

  biggerThanZero(formControlName: string) {
    return (formGroup: FormGroup) => {
      const formControl = formGroup.controls[formControlName];

      if (formControl.errors && !formControl.errors.biggerThanZero) {
        return;
      }

      if (formControl.value <= 0) {
        formControl.setErrors({ lessThanZero : true });
      } else {
        formControl.setErrors(null);
      }
    }

  }

  
}
